const FORM_SELECTOR = '#contact-form .wpforms-container';
const FIELD_SELECTOR = '.wpforms-field';
const EXCLUDED_FIELD_SELECTOR = [
    '.wpforms-field-select',
    '.wpforms-field-phone',
    '[data-field-type="select"]',
    '[data-field-type="phone"]',
].join(',');
const CONTROL_SELECTOR = [
    'input:not([type="submit"]):not([type="button"]):not([type="hidden"])',
    'textarea',
    'select',
].join(',');

function getForms(root) {
    const forms = Array.from(root.querySelectorAll(FORM_SELECTOR));

    if (root.matches?.(FORM_SELECTOR)) {
        forms.unshift(root);
    }

    return forms;
}

function controlHasValue(control) {
    const type = control.type;

    if (type === 'checkbox' || type === 'radio') {
        return control.checked;
    }

    return control.value.trim() !== '';
}

function fieldHasValue(field) {
    return Array.from(field.querySelectorAll(CONTROL_SELECTOR)).some(controlHasValue);
}

function syncField(field) {
    if (field.matches(EXCLUDED_FIELD_SELECTOR)) {
        field.classList.remove('is-filled');
        return;
    }

    field.classList.toggle('is-filled', fieldHasValue(field));
}

function syncControl(control) {
    const field = control.closest(FIELD_SELECTOR);

    if (field) {
        syncField(field);
    }
}

export default function init(root = document) {
    getForms(root).forEach((form) => {
        const fields = Array.from(form.querySelectorAll(FIELD_SELECTOR));

        fields.forEach(syncField);

        if (form.dataset.floatingLabelsReady === 'true') return;

        form.dataset.floatingLabelsReady = 'true';

        form.addEventListener('input', event => syncControl(event.target));
        form.addEventListener('change', event => syncControl(event.target));
    });
}
